import StatusIcon, { renderer, StatusConfigEntry } from "vamos/cockpit/base/control/StatusIcon";
import { DiscontinuedArticleStatusType } from "vamos/cockpit/data/masterdata/bmecat/discontinueditems/model/DiscontinuedArticleStatusType";

/**
 * @namespace vamos.cockpit.data.masterdata.bmecat.discontinueditems.control
 */

export default class DiscontinuedArticleStatusIcon extends StatusIcon<DiscontinuedArticleStatusType> {
  protected statusConfig: Record<DiscontinuedArticleStatusType, StatusConfigEntry> = {
    [DiscontinuedArticleStatusType.REPLACED]: { path: 'sap-icon://complete', color: 'green' },
    [DiscontinuedArticleStatusType.NEW]: { path: 'sap-icon://alert', color: 'orange' },
    [DiscontinuedArticleStatusType.NOT_REPLACED]: { path: 'sap-icon://decline', color: 'red' },
    [DiscontinuedArticleStatusType.IGNORED]: { path: 'sap-icon://hide', color: 'blue' },
  };

  static renderer = renderer
  rerender() {
    super.rerender();
  }
}